<template>
  <v-layout justify-center>
    <v-flex xs12>
      <v-container fluid>
        <v-layout row wrap justify-center mb-1>
          <v-btn slot="activator" @click="$router.push('/eventi/calendario')" hidden-sm-and-down xs6 class="btnDefault" small color="primary white--text" dark>
            <v-icon small class="mr-1">date_range</v-icon>Calendario
          </v-btn>
          <v-btn slot="activator" @click="dialogExportOpen()" class="btnDefault" small color="accent white--text" dark>
            <v-icon small class="mr-1">cloud_download</v-icon>Esporta Classifica generale
          </v-btn>
        </v-layout>

        <v-layout row wrap justify-left>
          <v-flex hidden-md-and-down xs5></v-flex>
          <v-flex grow text-xs-center>
            <v-layout fluid row wrap justify-left>
              <v-flex md1 class="px-1 text-xs-right mt-2 pa-0">
                <v-select v-model="filtroAnnoSportivo" :items="anniSportivi" box item-text="Descrizione" label="Anno Sportivo" return-object hide-details></v-select>
              </v-flex>
              <v-flex md2 class="px-1 text-xs-right mt-2">
                <v-autocomplete
                  v-model="filtroClasse"
                  :items="classi"
                  style="width: auto;"
                  box
                  clearable
                  item-text="Descrizione"
                  label="Classe"
                  return-object
                  hide-details
                ></v-autocomplete>
              </v-flex>
              <v-flex md2 class="px-1 text-xs-right mt-2">
                <v-autocomplete
                  v-model="filtroCategoria"
                  :items="evento_ibo ? categorieIBO : categorie"
                  style="width: auto;"
                  item-text="Descrizione"
                  box
                  clearable
                  label="Categoria"
                  return-object
                  hide-details
                ></v-autocomplete>
              </v-flex>
              <v-flex md2 class="px-1 text-xs-right mt-2">
                <v-autocomplete
                  v-model="filtroSezione"
                  :items="sezioni"
                  item-value="id"
                  item-text="Descrizione"
                  box
                  label="Regione"
                  clearable
                  return-object
                  hide-details
                ></v-autocomplete>
              </v-flex>
              <v-flex md2 class="px-1 text-xs-right mt-2">
                <v-autocomplete
                  v-model="filtroTipoGara"
                  :items="tipiEvento"
                  @change="evento_ibo_change()"
                  style="width: auto;"
                  item-text="Descrizione"
                  box
                  clearable
                  label="Tipo Gara"
                  return-object
                  hide-details
                ></v-autocomplete>
              </v-flex>
              <v-flex md1 class="px-1 text-xs-right mt-2" style="width: 150px;">
                <v-text-field v-model="filtroNumeroTessera" box label="Numero Pass" mask="#########" clearable hide-details></v-text-field>
              </v-flex>
              <v-flex md2 text-xs-center>
                <v-btn slot="activator" @click="refreshList()" class="btnDefault" small color="primary white--text" dark>
                  <v-icon small class="mr-1">cached</v-icon>Applica Filtro
                </v-btn>
                <v-btn slot="activator" @click="annullaFiltro()" class="btnDefault" small color="red white--text" dark>
                  <v-icon small class="mr-1">delete</v-icon>Annulla Filtro
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout justify-center style="width:320px, margin:auto">
          <v-flex md3 class="px-1 text-xs-right mt-2" style="width: 320px;">
            <v-text-field v-model="filtraTesto" box label="Cerca nei risultati filtrati" clearable hide-details></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout column>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="rankingFiltrate"
            :search="filtraTesto"
            :pagination.sync="pagination"
            :hide-headers="isMobile"
            :class="{ mobile: isMobile }"
            disable-initial-sort
            class="elevation-1 mt-3"
          >
            <template slot="items" slot-scope="props">
              <tr v-if="!isMobile" :style="{ color: getColorCategopria(props.item.categoriaCodice) }">
                <td class="text-xs-center">{{ props.item.classeCodice }}</td>
                <td class="text-xs-center">{{ props.item.categoriaCodice }}</td>
                <td class="text-xs-center">{{ props.item.descrizioneTipoEvento }}</td>
                <td class="text-xs-center">{{ Util.formattaData(props.item.DataEvento) }}</td>
                <td class="text-xs-left">{{ props.item.associazioneEventoDenominazione }}</td>
                <td class="text-xs-right">
                  {{ props.item.Posizione }}
                  {{ props.item.PosizioneRanking > 0 && props.item.PosizioneRanking != props.item.Posizione ? '(' + props.item.PosizioneRanking + ')' : '' }}
                </td>
                <td bold class="text-xs-left font-weight-bold">{{ props.item.Denominazione }}</td>
                <td class="text-xs-right">{{ props.item.NumeroTessera }}</td>
                <td bold class="text-xs-left">{{ props.item.associazioneDenominazione }}</td>
                <td bold class="text-xs-left">{{ props.item.descrizioneSezione }}</td>
                <td bold class="text-xs-right">{{ props.item.Punteggio }}</td>
                <td bold class="text-xs-right">{{ props.item.Spot }}</td>
                <td bold class="text-xs-right">{{ props.item.SuperSpot }}</td>
                <td bold class="text-xs-right">{{ props.item.Perfect }}</td>
              </tr>
              <tr v-else :active="props.selected" @click="props.selected = !props.selected">
                <td class="flex-td">
                  <ul class="flex-content" ma-10>
                    <li class="text-sm-center font-weight-bold flex-content" data-label="Denomiazione:  ">{{ props.item.Denominazione }}</li>
                    <li class="text-sm-center font-weight-bold flex-content" data-label="Classe:  ">{{ props.item.classeCodice }}</li>
                    <li class="text-sm-center font-weight-bold flex-content" data-label="Categoria:  ">{{ props.item.categoriaCodice }}</li>
                    <li class="text-sm-center font-weight-bold flex-content" data-label="Tipo Evento:  ">{{ props.item.descrizioneTipoEvento }}</li>
                    <li class="text-sm-center font-weight-bold flex-content" data-label="Data Evento:  ">{{ Util.formattaData(props.item.DataEvento) }}</li>
                    <li class="text-sm-center font-weight-bold flex-content" data-label="Associazione Evento:  ">{{ props.item.associazioneEventoDenominazione }}</li>
                    <li class="text-sm-center font-weight-bold flex-content" data-label="Posizione:  ">{{ props.item.Posizione }}</li>
                    <li class="text-sm-center font-weight-bold flex-content" data-label="N' Tessera:  ">{{ props.item.NumeroTessera }}</li>
                    <li class="text-sm-center font-weight-bold flex-content" bold data-label="Sodalizio:  ">{{ props.item.associazioneDenominazione }}</li>
                    <li class="text-sm-center font-weight-bold flex-content" bold data-label="Regione:  ">{{ props.item.descrizioneSezione }}</li>

                    <li class="text-sm-center font-weight-bold flex-content" bold data-label="Punteggio:  ">{{ props.item.Punteggio }}</li>
                    <li class="text-sm-center font-weight-bold flex-content" bold data-label="Spot:  ">{{ props.item.Spot }}</li>
                    <li class="text-sm-center font-weight-bold flex-content" bold data-label="SuperSpot:  ">{{ props.item.SuperSpot }}</li>
                    <li class="text-sm-center font-weight-bold flex-content" bold data-label="Perfect:  ">{{ props.item.Perfect }}</li>
                  </ul>
                </td>
              </tr>
            </template>
            <template slot="no-results">
              <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun risultato</v-alert>
            </template>
            <template slot="no-data">
              <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun risultato</v-alert>
            </template>
            <!-- PAGINAZIONE IN TABELLA  -->
            <template slot="pageText" slot-scope="props">Risultati {{ props.pageStart }} - {{ props.pageStop }} di {{ props.itemsLength }}</template>
          </v-data-table>
        </v-layout>
      </v-container>
      <v-dialog v-model="dialogExport" persistent max-width="490">
        <v-card>
          <v-card-title class="display-1 font-weight-bold accent white--text">Esportazione Classifica Generale</v-card-title>
          <v-card-text class="headline">Verrà esportata la classifica generale in formato Excel con il filtro selezionato</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialogExport = false" color="red white--text" class="btnDefault" flat small> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>
            <v-btn @click="exportClassificaGenerale()" color="accent white--text" dark> <v-icon small left>import_export</v-icon>Esporta </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex';
  import { bus } from '@/main';
  import Util from '@/util';
  import Security from '@/security';
  import FileEntity from './generale/FileEntity';
  import AssociazioneEntity from '@/pages/anagrafica/associazioni/AssociazioneEntity';
  import PartecipazioneEntity from './generale/PartecipazioneEntity';

  export default {
    components: {},
    data() {
      return {
        Util,
        ruoliUtente: Security.ruolo,
        elencoFunzioni: Security.enFunzione,
        formModes: Util.enFormMode,
        filtraStato: 'Tutti',
        filtraTesto: '',
        dialogExport: false,
        dialogClassifica: false,
        selected: [],
        prenotazioneDialog: false,
        evento_ibo: false,
        classi: [
          {
            Descrizione: 'Master Maschile',
            Codice: 'MM',
          },
          {
            Descrizione: 'Master Femminile',
            Codice: 'MF',
          },
          {
            Descrizione: 'Scout Maschile',
            Codice: 'SM',
          },
          {
            Descrizione: 'Scout Femminile',
            Codice: 'SF',
          },
          {
            Descrizione: 'Lupetto Maschile',
            Codice: 'LM',
          },
          {
            Descrizione: 'Lupetto Femminile',
            Codice: 'LF',
          },
          {
            Descrizione: 'Prime Freccie',
            Codice: 'PF',
          },
        ],
        isMobile: false,
        filtroAnno: null,
        filtroClasse: null,
        filtroTipoGara: null,
        filtroSezione: null,
        filtroCategoria: null,
        filtroNumeroTessera: null,
        filtroAnnoSportivo: null,
        headers: [
          {
            text: 'Classe',
            sortable: true,
            value: 'classeCodice',
            align: 'center',
            width: '80px',
          },
          {
            text: 'Categoria',
            sortable: true,
            value: 'categoriaCodice',
            align: 'center',
            width: '80px',
          },
          {
            text: 'Tipo',
            sortable: true,
            value: 'tipoEvento',
            align: 'center',
            width: '150px',
          },
          {
            text: 'Data Evento',
            sortable: true,
            value: 'DataEvento',
            align: 'center',
          },
          {
            text: 'Sodalizio Evento',
            sortable: true,
            value: 'associazioneEventoDenominazione',
            align: 'left',
          },
          {
            text: 'Posizione',
            sortable: true,
            value: 'Posizione',
            align: 'center',
          },
          {
            text: 'Arciere',
            sortable: true,
            value: 'Denominazione',
          },
          {
            text: 'Tessera',
            sortable: true,
            value: 'NumeroTessera',
            align: 'center',
            width: '80px',
          },
          {
            text: 'Sodalizio Arciere',
            sortable: true,
            value: 'Denominazione',
          },
          {
            text: 'Regione',
            sortable: true,
            value: 'sezione',
          },
          {
            text: 'Punteggio',
            sortable: true,
            value: 'Punteggio',
          },
          {
            text: 'Spot',
            sortable: true,
            value: 'Spot',
            align: 'center',
          },
          {
            text: 'Super',
            sortable: true,
            value: 'Super',
            align: 'center',
          },
          {
            text: 'Perfect',
            sortable: true,
            value: 'Perfect',
            align: 'center',
          },
        ],
        pagination: {
          rowsPerPage: 25,
        },
        editedItem: {},
      };
    },
    computed: {
      ...mapGetters('eventiModule', ['getClassificaGeneraleView']),
      ...mapGetters('sharedModule', ['getCategorieEvento', 'getCategorieEventoEuropeo', 'getTipiEvento', 'getSezioni', 'getAnniSportivi', 'getCategorieEventoIBO']),
      ...mapGetters(['isLogged', 'jwt']),
      ...mapGetters(['userData']),

      calculatedRow() {
        return this.$vuetify.breakpoint.name;
      },

      classifica() {
        return this.getClassificaGeneraleView;
      },
      categorie() {
        return this.getCategorieEvento.filter((p) => {
          return p.Codice != 'FO' && p.Codice != 'DI';
        });
      },
      categorieIBO() {
        return this.getCategorieEventoIBO;
      },
      categorieEuropeo() {
        return this.getCategorieEventoEuropeo;
      },
      anniSportivi() {
        return this.getAnniSportivi;
      },
      tipiEvento() {
        return this.getTipiEvento.filter((p) => {
          return p.Descrizione != 'Formazione' && p.Descrizione != 'Didattico' && p.Descrizione != 'Campionato europeo Indoor' && p.Descrizione != 'Campionato europeo outdoor';
        });
      },
      sezioni() {
        return this.getSezioni;
      },
      pages() {
        if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) {
          return 0;
        }
        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
      },
      rankingFiltrate() {
        let classificaList = null;
        if (this.classifica) {
          classificaList = this.classifica.filter((i) => {
            if (this.categoriaSelected == null) {
              return true;
            } else {
              return i.isAttivo == 1 && i.categoriaCodice == this.categoriaSelected.Codice;
            }
          });
          classificaList = classificaList.filter((i) => {
            if (this.classeSelected == null) {
              return true;
            } else {
              return i.Classe == this.classeSelected;
            }
          });

          return classificaList;
        } else {
          return this.classifica;
        }
      },
    },
    watch: {
      breakPoinSize() {
        switch (this.$vuetify.breakpoint.name) {
          case 'sm':
          case 'xs':
            this.isMobile = true;
            break;
          case 'md':
          case 'lg':
          case 'xl':
            this.isMobile = false;
            break;
        }
      },
      calculatedRow() {
        switch (this.$vuetify.breakpoint.name) {
          case 'sm':
          case 'xs':
            this.isMobile = true;
            break;
          case 'md':
            this.isMobile = false;
            break;
          case 'lg':
            this.isMobile = false;
            break;
          case 'xl':
            this.isMobile = false;
            break;
        }
      },
    },
    created() {
      const vm = this;
      vm.loadTipologie().then();
      this.filtroAnnoSportivo = {
        id: 322,
        Codice: '20262027',
        Descrizione: '2026/2027',
        Tipo: 'AnnoSportivo',
        Tag: null,
      };
      this.refreshList();

      switch (this.$vuetify.breakpoint.name) {
        case 'sm':
        case 'xs':
          this.isMobile = true;
          break;
        case 'md':
        case 'lg':
        case 'xl':
          this.isMobile = false;
          break;
      }
    },
    methods: {
      ...mapActions('eventiModule', ['loadClassificaGeneraleView', 'exportClassificaGeneraleXLS']),
      ...mapActions('sharedModule', ['loadTipologie']),
      refreshList() {
        const vm = this;
        vm.loadClassificaGeneraleView(
          this.createFilter(this.filtroAnno, this.filtroClasse, this.filtroCategoria, this.filtroNumeroTessera, this.filtroTipoGara, this.filtroSezione, this.filtroAnnoSportivo),
        );
      },

      dialogExportOpen() {
        const vm = this;
        vm.dialogExport = true;
      },

      annullaFiltro() {
        const vm = this;
        vm.filtroClasse = null;
        vm.filtroCategoria = null;
        vm.filtroNumeroTessera = null;
        vm.filtroTipoGara = null;
        vm.filtroSezione = null;
        vm.filtroAnnoSportivo = this.anniSportivi[0];
        vm.refreshList();
      },

      getColorCategopria(codiceCategoria) {
        if (this.categorie) {
          const cat = this.categorie.filter((a) => {
            return a.Codice == codiceCategoria;
          });
          if (cat.length == 1) {
            return cat[0].Tag.split('|');
          }
        }
      },
      createFilter(filtroAnno, filtroClasse, filtroCategoria, filtroNumeroTessera, filtroTipoGara, filtroSezione, filtroAnnoSportivo) {
        let filtro = {
          anno: filtroAnno,
          numeroTessera: filtroNumeroTessera,
          tipoGara: null,
          classe: null,
          categoria: null,
          sezione: null,
        };
        if (filtroClasse) {
          filtro.classe = filtroClasse.Codice;
        }

        if (filtroTipoGara) {
          filtro.tipoGara = filtroTipoGara.Codice;
        }

        if (filtroCategoria) {
          filtro.categoria = filtroCategoria.Codice;
        }

        if (filtroSezione) {
          filtro.sezione = filtroSezione.id;
        }

        if (filtroAnnoSportivo) {
          filtro.annoSportivo = filtroAnnoSportivo.id;
        }

        return filtro;
      },

      evento_ibo_change() {
        let codice = null;
        if (this.filtroTipoGara != undefined) {
          codice = this.filtroTipoGara.Codice;
        }
        if (codice === 'IBO_OUTDOOR' || codice === 'IBO_INDOOR' || codice === 'CI_IBO_INDOOR' || codice === 'CI_IBO_OUTDOOR' || codice ==='FIELD_IBO_OUTDOOR' || codice === 'National Indoor IBO' || codice === 'TC_IBO_OUTDOOR') {
          this.evento_ibo = true;
        } else {
          this.evento_ibo = false;
        }

        return this.evento_ibo;
      },

      checkFunzione(func) {
        return Security.isAbilitata(func, this.userData.Role);
      },
      exportClassificaGenerale() {
        const vm = this;
        vm.exportClassificaGeneraleXLS(
          this.createFilter(this.filtroAnno, this.filtroClasse, this.filtroCategoria, this.filtroNumeroTessera, this.filtroTipoGara, this.filtroSezione, this.filtroAnnoSportivo),
        );

        vm.dialogExport = false;
      },

      formatDate(date) {
        if (date) {
          return new Date(date).toLocaleString().split(',')[0];
        }
      },
    },
  };
</script>

<style scoped>
  .mobile table.v-table tr:nth-child(odd) {
    border-left: 2px solid grey;
    border-top: 2px solid grey;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 2px solid green;
    border-top: 2px solid green;
  }
</style>
